<template>
<v-container>
  <toast v-model="toastText"></toast>
  <v-layout row justify-center>
    <v-flex xs12 sm12 md8>
      <v-card>
        <v-list two-line subheader>
          <v-subheader>{{ $t('settings.permission_grant') }}</v-subheader>
          <v-list-tile avatar @click="copyToClip(token)">
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('settings.socketio_token') }}</v-list-tile-title>
              <v-list-tile-sub-title v-show="!loading">
                <span class="indigo--text" v-if="token">{{ token }}</span>
                <span class="grey--text" v-else>{{ $t('settings.no_token_defined') }}</span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action v-show="!loading">
              <v-btn icon v-on:click.stop="removeToken" :disabled="!userId" v-if="token">
                <v-tooltip left>
                  <v-icon color="primary" slot="activator">cloud_off</v-icon>
                  <span>{{ $t('settings.remove_token') }}</span>
                </v-tooltip>
              </v-btn>
              <v-btn icon v-on:click.stop="regenerateToken" :disabled="!userId" v-else>
                <v-tooltip left>
                  <v-icon ripple color="primary" slot="activator">vpn_key</v-icon>
                  <span>{{ $t('settings.generate_token') }}</span>
                </v-tooltip>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import {
  UserAuth
} from 'luffanet-web-components'

function makeToken() {
  const c = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  return Array(48).fill('').map(t => c.charAt(Math.floor(Math.random() * c.length))).join('');
}

export default {
  name: 'Settings',
  mixins: [UserAuth],
  data: () => ({
    toastText: null,
    loading: true,
    token: null
  }),
  methods: {
    load() {
      this.$db.ref('socketioToken').child(this.userId).on('value', snapshot => {
        this.token = snapshot.val();
        this.loading = false;
      });
    },
    async copyToClip(data) {
      try {
        await this.$copyText(data);
        this.toastText = this.$t('settings.data_copied', {
          data: data
        });
      } catch (err) {
        console.log(err);
      }
    },
    regenerateToken() {
      this.$db.ref('socketioToken').child(this.userId).set(makeToken());
      this.toastText = this.$t('settings.update_token_successfully');
    },
    removeToken() {
      this.$db.ref('socketioToken').child(this.userId).remove();
      this.toastText = this.$t('settings.remove_token_successfully');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings.vue